import React, { useState, useEffect, useRef } from 'react'

import {
  Form,
  Input,
  Tag,
  ModalProps,
  FormProps,
  Modal,
  Space,
  Button,
  Row,
  Col,
  Select,
  Divider,
  useSelect,
  Descriptions,
  Typography,
  Tooltip,
} from '@pankod/refine-antd'
import { useCreateMany, useGetIdentity, useList, useMany, useTable } from '@pankod/refine-core'
import ReactMarkdown from 'react-markdown'
import ReactMde from 'react-mde'
// import ReactRichEditor from 'react-rich-text-editor'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'

import 'react-mde/lib/styles/css/react-mde-all.css'
import {
  IGrade,
  ISubject,
  ITopic,
  IBloomLevel,
  ITeacherLevel,
  IDifficultyLevel,
  IQuestion,
  IQuestionType,
  IWorkRequest,
  IReportTheme,
  ISubTheme,
  ITheme,
  IAspect,
  ICentaConcept,
  ITNTaxonomy,
  ICompetency,
  IStrand,
  IExplanationTypes,
  IWorkRequestGrades,
} from 'interfaces'
import { nhost } from 'utility'
import { createLogOpen, getLastCreatedQuestion, updateWorkRequestStatus, createLogForReview } from 'gql/mutations'
import { ReactMdeToolbarCommands } from 'helpers/markdownConfig'
import { useUserContext } from 'context/user'
import { Editor } from '@tinymce/tinymce-react'
import RichTextEditor from 'components/questions/rich_text_editor'
import RichTextRender from 'components/questions/rich_text_render'
import SunTextEditor from 'components/questions/sun_text_editor'

// import axios from 'axios'
const { TextArea } = Input
type CreateQuestionProps = {
  modalProps: ModalProps
  formProps: FormProps
  request?: any
  gradeList?: any
}

type BlobInfo = {
  id: () => string
  name: () => string
  filename: () => string
  blob: () => Blob
  base64: () => string
  blobUri: () => string
  uri: () => string | undefined
}

type ProgressFn = (percent: number) => void

type UploadHandler = (blobInfo: BlobInfo, progress: ProgressFn) => Promise<string>
interface OptionTab {
  [key: string]: 'write' | 'preview'
}
export const CreateDraftQuestionFromPaper: React.FC<CreateQuestionProps> = ({ modalProps, formProps, request, gradeList }) => {
  const { data: user } = useGetIdentity()
  const { userRole, qapproverList, qreviewerList } = useUserContext()
  const [selectedTab, setSelectedTab] = useState<'write' | 'preview'>('write')
  const [questionType, setQuestionType] = useState('MCQ')
  const [optionType, setOptionType] = useState('Text')
  const [selectedItems, setSelectedItems] = useState<string>('')
  const [error, setError] = useState<boolean>(false)
  const { Option } = Select
  const [taxonomyfilter, setTaxonomyFilter] = useState<any[]>([])
  const [taxonomyRequired, setTaxonomyRequired] = useState(true)
  const [strandfilter, setStrandFilter] = useState<any[]>([])
  const [subjectFilter, setReportThemeFIlter] = useState<any[]>([])
  const [selectedOptionTab, setSelectedOptionTab] = useState<string[]>([])
  const [approverList, setApproverList] = useState<any[]>([])
  const [reviewerList, setReviewerList] = useState<any[]>([])
  const { mutate: createGrades } = useCreateMany<IWorkRequestGrades>()
  const option_tags = ['Right Answer', 'Most Wrong', 'Close to Correct']
  const filteredOptions = option_tags?.filter(o => selectedItems !== o)
  const editorRef = useRef<Editor>(null)

  {
    /*Variant Selection ****************/
  }

  console.log('incoming request data', request)

  {
    /*Variant Selection ****************/
  }

  //file upload start ------------------------------
  const [fileList, setFileList] = useState<any>({})
  const [uploading, setUploading] = useState(false)

  const handleImageUpload = async (option_details: any) => {
    setUploading(true)
    let metadatas: any = {}
    for (let key = 0; key < option_details.length; key++) {
      const file = option_details[key]?.option_image_id.file
      const { fileMetadata } = await nhost.storage.upload({ file })

      metadatas[key] = fileMetadata
    }
    setUploading(false)
    return metadatas
  }
  const handleUploadDescriptionImage = () => {}
  //file upload end ---------------------------

  // Tags
  const { selectProps: bloomlevelSelectProps } = useSelect<IBloomLevel>({
    resource: 'blooms_levels',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'order', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const { selectProps: competencySelectProps } = useSelect<ICompetency>({
    resource: 'competencies',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 100,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const { selectProps: tntaxonomySelectProps } = useSelect<ITNTaxonomy>({
    resource: 'tn_taxonomys',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'competency_id'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: taxonomyfilter,
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const { selectProps: strandSelectProps } = useSelect<IStrand>({
    resource: 'strands',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'teacher_level_id', 'taxonomy_id', 'competency_id'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: strandfilter,
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const { selectProps: difficultylevelSelectProps } = useSelect<IDifficultyLevel>({
    resource: 'difficulty_levels',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'order', order: 'asc' }],
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const { selectProps: questionTypeSelectProps } = useSelect<IQuestionType>({
    resource: 'question_types',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    queryOptions: { enabled: !!modalProps?.visible && !!!request?.question_type_id },
  })

  const { selectProps: reportThemeProps } = useSelect<IReportTheme>({
    resource: 'report_themes',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    filters: subjectFilter,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    queryOptions: { enabled: !!modalProps?.visible && !!!request?.report_theme_id },
  })

  const {
    filters: themeFilters,
    setFilters: setThemeFilters,
    tableQueryResult: themeResult,
  } = useTable<ITheme>({
    queryOptions: { enabled: !!!request?.theme_id && !!modalProps?.visible },
    resource: 'themes',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'subject_id', 'report_theme_id'] },
    initialFilter: [
      {
        field: 'subject_id',
        operator: 'eq',
        value: request?.subject_id,
      },
    ],
  })

  const {
    filters: subThemeFilters,
    setFilters: setSubThemeFilters,
    tableQueryResult: subThemeResult,
  } = useTable<ISubTheme>({
    resource: 'sub_themes',
    queryOptions: { enabled: !!!request?.sub_theme_id && modalProps?.visible },
    metaData: { fields: ['id', 'name', 'theme_id'] },
    initialPageSize: 1000,
    initialFilter: [
      {
        field: 'theme_id',
        operator: 'eq',
        value: request?.theme_id,
      },
    ],
  })

  const {
    filters: topicFilters,
    setFilters: setTopicFilters,
    tableQueryResult: topicResult,
    sorter,
  } = useTable<ITopic>({
    resource: 'topics',
    queryOptions: { enabled: !!!request?.topic_id && modalProps?.visible },
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'sub_theme_id'] },
    initialFilter: [
      {
        field: 'sub_theme_id',
        operator: 'eq',
        value: request?.sub_theme_id ,
      },
    ],
  })

  const handleReportThemeChange = (value: any) => {
    setThemeFilters(
      [
        {
          field: 'report_theme_id',
          operator: 'eq',
          value,
        },
      ],
      'replace'
    )
  }

  const handleThemeChange = (value: string) => {
    setSubThemeFilters([{ field: 'theme_id', operator: 'eq', value }], 'replace')
  }
  const handleSubThemeChange = (value: string) => {
    setTopicFilters([{ field: 'sub_theme_id', operator: 'eq', value }], 'replace')
  }

  const handleQuestionType = (value: any) => {
    setQuestionType(value)
  }
  const handleOptionType = (value: any) => {
    setOptionType(value)
  }

  const handleCompetencyChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      tn_taxonomy_id: null,
      teacher_level_id: null,
      strand_id: null,
    })
    let data: any = [
      {
        field: 'competency_id',
        operator: 'eq',
        value: value,
      },
    ]
    setTaxonomyFilter(data)
    setStrandFilter(data)
  }
  const handleTaxonomyChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      teacher_level_id: null,
      strand_id: null,
    })
    let arr: any[] = [...strandfilter]
    let data: any = {
      field: 'taxonomy_id',
      operator: 'eq',
      value: value,
    }
    arr.push(data)

    setStrandFilter(arr)
  }

  useEffect(() => {
    ;(async function setReviewerandApprover() {
      if (modalProps?.visible) {
        const reviewerResult = qreviewerList?.map((user: any) => {
          return { label: user?.displayName, value: user?.id }
        })
        setReviewerList(reviewerResult)

        const approverResult = qapproverList?.map((user: any) => {
          return { label: user?.displayName, value: user?.id }
        })
        setApproverList(approverResult)
      }
    })()
  }, [modalProps?.visible])

  const onFinish = async (values: any) => {
    let is_ra_found = false
    //image option transform
    let option_array: any = []
    if (questionType === 'MCQ' && values?.option_details?.length > 0) {
      values.option_details.forEach((option: any, index: number) => {
        let newOption = { ...option }
        if (option?.option_text.includes('![image]')) {
          const middle = option?.option_text?.slice(option?.option_text.lastIndexOf('/') + 1, option?.option_text?.length - 1)
          console.log({ middle })
          newOption.option_image_id = middle
          newOption.type = 'Image'
          // newOption.option_image_name = ''
        } else if (option?.option_text?.includes('<img')) {
          let imgTagPattern = /<img.*?>/
          let imgTagMatch = option?.option_text?.match(imgTagPattern)
          let imgTagString = imgTagMatch ? imgTagMatch[0] : ''
          let imgSrc = imgTagString.split('"')?.[1] ?? ''
          let imgId = imgSrc?.slice(imgSrc?.lastIndexOf('/') + 1)
          newOption['option_image_id'] = imgId
          newOption['type'] = 'Image'
          console.log('iddd', imgId, option)
        } else {
          newOption['type'] = 'Text'
        }
        option_array.push(newOption)
        console.log('first', option?.option_flag, option?.option_flag === 'Right Answer')
        if (is_ra_found) {
          return
        }
        if (option?.option_flag === 'Right Answer') {
          is_ra_found = true
          return
        } else {
          is_ra_found = false
        }
      })
    } else if (questionType === 'Match' && values?.option_details?.length > 0) {
      option_array = []
      values.option_details.forEach((option: any, index: number) => {
        let newOption = { ...option }
        // LEFT LABEL
        if (option?.left_label_text.includes('![image]')) {
          let left_middle = option?.left_label_text?.slice(option?.left_label_text.lastIndexOf('/') + 1, option?.left_label_text?.length - 1)
          newOption.left_label_image = left_middle
          newOption.type = 'Image'
        } else if (option?.left_label_text?.includes('<img')) {
          let imgTagPattern = /<img.*?>/
          let imgTagMatch = option?.left_label_text?.match(imgTagPattern)
          let imgTagString = imgTagMatch ? imgTagMatch[0] : ''
          let imgSrc = imgTagString.split('"')?.[1] ?? ''
          let imgId = imgSrc?.slice(imgSrc?.lastIndexOf('/') + 1)
          newOption['left_label_image'] = imgId
          newOption['type'] = 'Image'
        } else {
          newOption['type'] = 'Text'
          newOption['left_label_image'] = null
        }
        // RIGHT LABEL
        if (option?.right_label_text.includes('![image]')) {
          let right_middle = option?.right_label_text?.slice(option?.right_label_text.lastIndexOf('/') + 1, option?.right_label_text?.length - 1)
          newOption.right_label_image = right_middle
          newOption.type = 'Image'
        } else if (option?.right_label_text?.includes('<img')) {
          let imgTagPattern = /<img.*?>/
          let imgTagMatch = option?.right_label_text?.match(imgTagPattern)
          let imgTagString = imgTagMatch ? imgTagMatch[0] : ''
          let imgSrc = imgTagString.split('"')?.[1] ?? ''
          let imgId = imgSrc?.slice(imgSrc?.lastIndexOf('/') + 1)
          newOption['right_label_image'] = imgId
          newOption['type'] = 'Image'
        } else {
          // newOption.type = 'Text'
          newOption['right_label_image'] = null
        }
        option_array.push(newOption)
      })
    }

    console.log({ option_array })
    // if (values.option_type === 'Image') {
    //   const metadatas = await handleImageUpload(values.option_details)
    //   values.option_details.forEach((option: any, index: number) => {
    //     let newOption = { ...option }
    //     newOption.option_image_id = metadatas[index].id
    //     newOption.option_image_name = metadatas[index].name
    //     image_option_details.push(newOption)
    //   })
    // }

    // work request status change
    if (request?.status === 'Open') {
      updateWorkRequestStatus(request?.id, 'In Progress')
    }
    if (option_array?.length > 0 && questionType === 'MCQ') {
      setError(!is_ra_found)
    }
    // let option_details
    // if (questionType === 'MCQ' || questionType === 'Match') {
    //   option_details = option_array
    // } else {
    //   option_details = values?.option_details
    // }
    const questionTitle = editorRef?.current?.editor?.getContent()
    if (!uploading) {
      if (questionType === 'MCQ') {
        if (option_array.length > 0) {
          if (is_ra_found) {
            return (
              formProps.onFinish &&
              formProps.onFinish({
                ...values,
                status: 'Draft',
                option_type: '',
                option_details: option_array,
                // work_request_id: request?.id,
                question_type_id: request?.question_type_id,
                // creator_id: request?.creator_id,
                creator_id: user?.id,
                subject_id: request?.subject_id,
                bloom_level_id: request?.blooms_level_id ?? values?.bloom_level_id,
                centa_standard_id: request?.centa_standard_id ?? values?.centa_standard_id,
                difficulty_level_id: request?.difficult_level_id ?? values?.difficulty_level_id,
                // grade_ids: request?.grade_ids?.length > 0 ? request?.grade_ids : values?.grade_ids,
                grade_ids: getListOfGrades,
                theme_id: request?.theme_id ?? values?.theme_id,
                sub_theme_id: request?.sub_theme_id ?? values?.sub_theme_id,
                topic_id: request?.topic_id ?? values?.topic_id,
                report_theme_id: null,
                // report_theme_id: request?.report_theme_id ?? values?.report_theme_id,
                strand_id: request?.strand_id ?? values?.strand_id,
                teacher_level_id: request?.teacher_level_id ?? values?.teacher_level_id,
                competency_id: request?.competency_id ?? values?.competency_id,
                centa_concept_id: request?.centa_concept_id ?? values?.centa_concept_id,
                tn_taxonomy_id: request?.taxonomy_id ?? values?.tn_taxonomy_id,
                paper_id: request?.paperId,
              })
            )
          }
        } else {
          return (
            formProps.onFinish &&
            formProps.onFinish({
              ...values,
              status: 'Draft',
              option_type: '',
              option_details: values?.option_details,
              // work_request_id: request?.id,
              question_type_id: request?.question_type_id,
              // creator_id: request?.creator_id,
              creator_id: user?.id,
              subject_id: request?.subject_id,
              bloom_level_id: request?.blooms_level_id ?? values?.bloom_level_id,
              centa_standard_id: request?.centa_standard_id ?? values?.centa_standard_id,
              difficulty_level_id: request?.difficult_level_id ?? values?.difficulty_level_id,
              // grade_ids: request?.grade_ids?.length > 0 ? request?.grade_ids : values?.grade_ids,
              grade_ids: getListOfGrades,
              theme_id: request?.theme_id ?? values?.theme_id,
              sub_theme_id: request?.sub_theme_id ?? values?.sub_theme_id,
              topic_id: request?.topic_id ?? values?.topic_id,
              report_theme_id: null,
              // report_theme_id: request?.report_theme_id ?? values?.report_theme_id,
              strand_id: request?.strand_id ?? values?.strand_id,
              teacher_level_id: request?.teacher_level_id ?? values?.teacher_level_id,
              competency_id: request?.competency_id ?? values?.competency_id,
              centa_concept_id: request?.centa_concept_id ?? values?.centa_concept_id,
              tn_taxonomy_id: request?.taxonomy_id ?? values?.tn_taxonomy_id,
              paper_id: request?.paperId,
            })
          )
        }
      } else if (questionType === 'Match') {
        return (
          formProps.onFinish &&
          formProps.onFinish({
            ...values,
            status: 'Draft',
            option_type: '',
            option_details: option_array,
            // work_request_id: request?.id,
            question_type_id: request?.question_type_id,
            creator_id: user?.id,
            subject_id: request?.subject_id,
            bloom_level_id: request?.blooms_level_id ?? values?.bloom_level_id,
            centa_standard_id: request?.centa_standard_id ?? values?.centa_standard_id,
            difficulty_level_id: request?.difficult_level_id ?? values?.difficulty_level_id,
            grade_ids: getListOfGrades,
            theme_id: request?.theme_id ?? values?.theme_id,
            sub_theme_id: request?.sub_theme_id ?? values?.sub_theme_id,
            topic_id: request?.topic_id ?? values?.topic_id,
            report_theme_id: null,
            // report_theme_id: request?.report_theme_id ?? values?.report_theme_id,
            strand_id: request?.strand_id ?? values?.strand_id,
            teacher_level_id: request?.teacher_level_id ?? values?.teacher_level_id,
            competency_id: request?.competency_id ?? values?.competency_id,
            centa_concept_id: request?.centa_concept_id ?? values?.centa_concept_id,
            tn_taxonomy_id: request?.taxonomy_id ?? values?.tn_taxonomy_id,
            paper_id: request?.paperId,
          })
        )
      } else {
        return (
          formProps.onFinish &&
          formProps.onFinish({
            ...values,
            status: 'Draft',
            option_type: '',
            option_details: values?.option_details,
            // work_request_id: request?.id,
            question_type_id: request?.question_type_id,
            // creator_id: request?.creator_id,
            creator_id: user?.id,
            subject_id: request?.subject_id,
            bloom_level_id: request?.blooms_level_id ?? values?.bloom_level_id,
            centa_standard_id: request?.centa_standard_id ?? values?.centa_standard_id,
            difficulty_level_id: request?.difficult_level_id ?? values?.difficulty_level_id,
            grade_ids: getListOfGrades,
            theme_id: request?.theme_id ?? values?.theme_id,
            sub_theme_id: request?.sub_theme_id ?? values?.sub_theme_id,
            topic_id: request?.topic_id ?? values?.topic_id,
            report_theme_id: null,
            // report_theme_id: request?.report_theme_id ?? values?.report_theme_id,
            strand_id: request?.strand_id ?? values?.strand_id,
            teacher_level_id: request?.teacher_level_id ?? values?.teacher_level_id,
            competency_id: request?.competency_id ?? values?.competency_id,
            centa_concept_id: request?.centa_concept_id ?? values?.centa_concept_id,
            tn_taxonomy_id: request?.taxonomy_id ?? values?.tn_taxonomy_id,
            paper_id: request?.paperId,
          })
        )
      }
    }
  }

  useEffect(() => {
    if (request && request.question_type_id) {
      setQuestionType(request.question_type_id)
    }
    setReportThemeFIlter([{ field: 'subject_id', operator: 'eq', value: request?.subject_id }])
  }, [request])
  useEffect(() => {
    if (userRole === 'qcreator' || userRole === 'variantcreator') {
      setTaxonomyRequired(false)
    }
  }, [userRole])

  const getListOfGrades = gradeList ?? []

  const { selectProps: gradeSelectProps, queryResult: gradeQueryResult } = useSelect<IGrade>({
    defaultValue: getListOfGrades,
    resource: 'grades',
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      {
        field: 'id',
        operator: 'in',
        value: getListOfGrades,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const handleValueChange = (value: any, key: any) => {
    console.log({ value, key })
  }

  const save = async function* (data: any) {
    const wait = function (time: any) {
      return new Promise<void>((a, r) => {
        setTimeout(() => a(), time)
      })
    }
    var arrayBufferView = new Uint8Array(data)
    var blob = new Blob([arrayBufferView], { type: 'image/jpeg' })
    var file = new File([blob], 'image.jpg')

    const { fileMetadata } = await nhost.storage.upload({ file })
    const publicUrl = nhost.storage.getPublicUrl({ fileId: fileMetadata?.id || '' })

    await wait(2000)
    // yields the URL that should be inserted in the markdown

    yield publicUrl
    await wait(2000)
    return true
  }
  const saveOptions = async function* (data: any) {
    // console.log('first-----', key)
    const wait = function (time: any) {
      return new Promise<void>((a, r) => {
        setTimeout(() => a(), time)
      })
    }
    var arrayBufferView = new Uint8Array(data)
    var blob = new Blob([arrayBufferView], { type: 'image/jpeg' })
    var file = new File([blob], 'image.jpg')
    const { fileMetadata } = await nhost.storage.upload({ file })
    console.log({ fileMetadata })
    let url = nhost.storage.getPublicUrl({ fileId: fileMetadata?.id || '' })

    await wait(2000)
    // yields the URL that should be inserted in the markdown

    yield url
    await wait(2000)
    return true
  }
  // const handleOptionTags = (value: string) => {
  const handleOptionTags = (value: string) => {
    if (questionType === 'MCQ') {
      const field = formProps?.form?.getFieldValue('option_details')
      const found = field?.findIndex((element: any) => element?.option_flag === 'Right Answer')
      if (found === -1) {
        setSelectedItems('')
      } else {
        setSelectedItems('Right Answer')
      }
    }
  }
  const handleOptionTabChange = (value: any, key: any) => {
    let arr: string[] = [...selectedOptionTab]
    if (value === 'preview') {
      arr.push(key)
    }
    if (value === 'write') {
      if (arr.includes(key)) {
        arr.splice(arr.indexOf(key), 1)
      }
    }
    console.log({ arr })
    setSelectedOptionTab(arr)
  }

  const handleImageUplodFromEditor: UploadHandler = async (blobInfo, progress) => {
    let url = ''
    try {
      const fileName = blobInfo?.filename()
      const blob = blobInfo?.blob()
      const file = new File([blob], fileName)
      const { fileMetadata } = await nhost.storage.upload({ file })
      const fileId = fileMetadata?.id ?? ''
      url = await nhost.storage.getPublicUrl({ fileId })
    } catch (err) {
      console.log({ err })
    }
    return Promise.resolve(url)
  }

  const handleSetFormList = (content: string, key: number, fieldName: string) => {
    const optionsArr = formProps?.form?.getFieldValue('option_details')
    console.log(optionsArr,'options arr')
    console.log({ optionsArr })
    if (optionsArr?.[key] === undefined) {
      optionsArr[key] = { [fieldName]: content }
    }
    const formVal = optionsArr?.[key]
    Object.assign(formVal, { ...formVal, [fieldName]: content })
    formProps?.form?.setFieldsValue({ option_details: optionsArr })
  }

  // console.log({ value })
  // }

  return (
    <Modal
      {...modalProps}
      title="Create Draft Question"
      afterClose={() => {
        formProps?.form?.resetFields()
      }}
    >
      {JSON.stringify(request) !== '{}' && request?.id !== '' ? (
        <>
          <Descriptions size="small" column={3} labelStyle={{ fontWeight: 500, maxWidth: '50%' }} contentStyle={{ width: 'maxWidth' }}>
            {request?.subject?.name && <Descriptions.Item label="Subject">{request?.subject?.name}</Descriptions.Item>}
            {request?.report_theme?.name && <Descriptions.Item label="Report Theme (TN_TERM_MONTH)">{request?.report_theme?.name}</Descriptions.Item>}
            {request?.theme?.name && <Descriptions.Item label="Theme (TN Chapter Name)">{request?.theme?.name}</Descriptions.Item>}
            {request?.sub_theme?.name && (
              <Descriptions.Item label="Sub Theme (CENTA Concept ID_CENTA Concept Name)">{request?.sub_theme?.name}</Descriptions.Item>
            )}
            {request?.topic?.name && <Descriptions.Item label="Topic">{request?.topic?.name}</Descriptions.Item>}
            {request?.question_type?.name && <Descriptions.Item label="Question Type">{request?.question_type?.name}</Descriptions.Item>}
            <Descriptions.Item label="Grades">
              {getListOfGrades.length > 0 ? (
                gradeQueryResult?.data?.data?.map(({ id, name }) => <Typography.Text keyboard>{name}</Typography.Text>)
              ) : (
                <Select {...gradeSelectProps} mode="multiple" showSearch={false} />
              )}
            </Descriptions.Item>
            {request?.bloom_level?.name && <Descriptions.Item label="Blooms Level">{request?.bloom_level?.name}</Descriptions.Item>}
            {request?.difficulty_level?.name && <Descriptions.Item label="Difficulty Level">{request?.difficulty_level?.name}</Descriptions.Item>}
          </Descriptions>

          {/* <b>Tags:</b>
          <Descriptions size="small" column={2}>
            {request?.competencies?.name && <Descriptions.Item label="Competency">{request?.competencies?.name}</Descriptions.Item>}
            {request?.taxonomy?.name && <Descriptions.Item label="Taxonomy">{request?.taxonomy?.name}</Descriptions.Item>}
            {request?.teacher_level?.name && <Descriptions.Item label="Teacher Level">{request?.teacher_level?.name}</Descriptions.Item>}
            {request?.strands?.name && <Descriptions.Item label="Standard">{request?.strands?.name}</Descriptions.Item>}
            {request?.bloom_level?.name && <Descriptions.Item label="Bloom Level">{request?.bloom_level?.name}</Descriptions.Item>}
            {request?.difficulty_level?.name && <Descriptions.Item label="Difficulty">{request?.difficulty_level?.name}</Descriptions.Item>}

            {request?.centa_concept?.name && <Descriptions.Item label="Centa Concept">{request?.centa_concept?.name}</Descriptions.Item>}
          </Descriptions> */}
        </>
      ) : null}
      <Row gutter={[16, 0]}>
        <Col xs={24} lg={24}>
          <Divider orientation="left" orientationMargin="0" className="primary">
            Question Details
          </Divider>
        </Col>
      </Row>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={values => {
          onFinish(values)
            .then(() => getLastCreatedQuestion())
            .then((resp: any) => {
              const question = resp?.questions[0]
              createLogOpen(question?.creator_id, undefined, question?.id, request)
              // createLogForReview(question?.creator_id, undefined, question?.id, request?.paperId)
              let grade_array: object[] = []
              if (values?.grade_ids?.length > 0 || getListOfGrades?.length > 0) {
                if (values?.grade_ids?.length > 0) {
                  values?.grade_ids?.map((item: any) => {
                    grade_array.push({
                      grade_id: item,
                      question_id: question?.id,
                    })
                  })
                } else if (getListOfGrades?.length > 0) {
                  getListOfGrades?.map((item: any) => {
                    grade_array.push({
                      grade_id: item,
                      question_id: question?.id,
                    })
                  })
                }

                createGrades({
                  resource: 'question_grades',
                  values: grade_array,
                })
              }
              setSelectedItems('')
              setError(false)
            })
        }}
      >
        <Row gutter={[16, 0]}>
          {JSON.stringify(request) === '{}' || request?.question_type_id === '' || request?.question_type_id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Question Type" name="question_type" initialValue={'MCQ'} rules={[{ required: true }]}>
                <Select onChange={handleQuestionType} {...questionTypeSelectProps} />
              </Form.Item>
            </Col>
          ) : null}
          {JSON.stringify(request) === '{}' || request?.grade_ids?.length <= 0 || request?.grade_ids === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Grade" name="grade_ids">
                {getListOfGrades.length > 0 ? (
                  gradeQueryResult?.data?.data?.map(({ id, name }) => <Typography.Text keyboard>{name}</Typography.Text>)
                ) : (
                  <Select {...gradeSelectProps} mode="multiple" showSearch={false} />
                )}
              </Form.Item>
            </Col>
          ) : null}
          {/* {JSON.stringify(request) === '{}' || request?.report_theme_id === '' || request?.report_theme_id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item
                label="Report Theme (TN_Term_Month)"
                name="report_theme_id"
                rules={[{ required: true }]}
                initialValue={request?.report_theme_id}
              >
                <Select
                  {...reportThemeProps}
                  onChange={value => {
                    handleReportThemeChange(value)
                  }}
                />
              </Form.Item>
            </Col>
          ) : null} */}
          {JSON.stringify(request) === '{}' || request?.theme_id === '' || request?.theme_id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Theme (TN Chapter Name)" name="theme_id" rules={[{ required: true }]}>
                <Select
                  onChange={value => {
                    handleThemeChange(value)
                  }}
                >
                  {themeResult?.data?.data?.map(theme => (
                    <option key={theme?.name} value={theme?.id}>
                      {theme?.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {JSON.stringify(request) === '{}' || request?.sub_theme_id === '' || request?.sub_theme_id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Sub-theme (CENTA Concept ID_CENTA Concept Name)" name="sub_theme_id" rules={[{ required: true }]}>
                <Select
                  onChange={value => {
                    handleSubThemeChange(value)
                  }}
                >
                  {subThemeResult?.data?.data?.map(subTheme => (
                    <option key={subTheme?.name} value={subTheme?.id}>
                      {subTheme?.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {JSON.stringify(request) === '{}' || request?.topic_id === '' || request?.topic_id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Topic" name="topic_id" rules={[{ required: false }]}>
                <Select>
                  {topicResult?.data?.data?.map(topic => (
                    <option key={topic?.name} value={topic?.id}>
                      {topic?.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {/* {request?.variant_options !== '' && request?.variant_options !== null ? (
            <Col xs={24} lg={16}>
              <Form.Item label="Variant Of" name="parent_question_id" rules={[{ required: true }]}>
                <Select>
                  {variantList.map((item: any) => (
                    <option key={item.question_id} value={item.id}>
                      {item.title}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null} */}
          <Col xs={24} lg={8}>
            <Form.Item label="Select Variant (optional)" name="parent_question_id">
              <Select allowClear>
                {request?.selectableQuestions?.map((eachQuestion: any) => (
                  <option key={eachQuestion?.id} value={eachQuestion?.id} label={eachQuestion?.title}>
                    <RichTextRender
                      key={eachQuestion?.id}
                      prefixContent={`#${eachQuestion?.question_id}-`}
                      content={eachQuestion?.title}
                      styles={{ width: '120px', height: '50px' }}
                    />
                    {/* <Tooltip title={eachQuestion?.title}>{eachQuestion?.title}</Tooltip> */}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={24}>
            <Form.Item
              label="Question"
              name="title"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              {/* <ReactRichEditor height={200} /> */}
              {/* <ReactMde
                selectedTab={selectedTab}
                onTabChange={setSelectedTab}
                // style={{outerHeight:100}}

                generateMarkdownPreview={markdown => Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>)}
                toolbarCommands={ReactMdeToolbarCommands}
                paste={{
                  saveImage: save,
                }}
              /> */}
              <>
                <>
                  {/* <RichTextEditor
                    id={`question_title${request?.id}`}
                    formValueSetterFn={(content: string) => {
                      formProps?.form?.setFieldsValue({ title: content })
                    }}
                  /> */}
                  <SunTextEditor
                   key={`question_title${request?.id}`}
                   id={`question_title${request?.id}`}
                   formValueSetterFn={(content: string) => {
                     formProps?.form?.setFieldsValue({ title: content })
                   }}
                  />
                </>
              </>
            </Form.Item>
          </Col>
          <Col xs={24} lg={24}>
            <Form.Item name={'question_insight'} label="Question Insight" rules={[{ required: false }]}>
              {/* <TextArea rows={4} placeholder="Question Insight" disabled={userRole === 'qreviewer' || userRole === 'qapprover'} /> */}
              <SunTextEditor
               key={`question_insight${request?.id}`}
                  id="question_insight"
                  formValueSetterFn={(content: string) => {
                    formProps?.form?.setFieldsValue({ question_insight: content })
                  }}
                />
            </Form.Item>
          </Col>
          {questionType === 'ShortAnswer' && (
            <Col xs={24} lg={24}>
              <Form.Item label="Expected points in the answer" name="description">
                <Input />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={24}>
            <Divider orientation="left" orientationMargin="0" className="primary">
              {questionType === 'ShortAnswer' && 'Rubric Details'}
              {questionType === 'MCQ' && 'Option Details'}
              {questionType === 'Match' && 'Label Details'}
              {questionType === 'Fill' && 'Answer Details'}
            </Divider>
          </Col>
          {/* {questionType === ('MCQ' || 'Match') && ( */}
          {/* {questionType === 'MCQ' && (
            // <Col xs={24} lg={12}>
            //   <Form.Item label="Options Type" name="option_type" initialValue={'Text'}>
            //     <Select
            //       onChange={handleOptionType}
            //       options={[
            //         { label: 'Text', value: 'Text' },
            //         { label: 'Image', value: 'Image' },
            //       ]}
            //     />
            //   </Form.Item>
            // </Col>
          )} */}
        </Row>
        {questionType === 'MCQ' && (
          <Form.List
            name="option_details"
            rules={[
              {
                validator: async (_, option_details) => {
                  console.log({ option_details })
                  if (option_details === undefined) {
                    return Promise.reject(new Error('Add at least 1 option'))
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                {fields.map(({ key, name, ...restField },index) => (
                  // <Space key={key} style={{ display: 'flex', marginBottom: 8, width: '100%' }} align="baseline">
                  <Row gutter={[8, 16]} style={{ display: 'flex', alignItems: 'center' }}>
                    <Col lg={11}>
                      <Form.Item 
                      {...restField} 
                       label="Option Text"
                           name={[name, 'option_text']} 
                           rules={[{ required: true, message: 'Missing Option Value' }]}>
                        {/* {console.log('selectedOptionTab', selectedOptionTab)} */}
                        {/* <ReactMde
                          selectedTab={selectedOptionTab?.includes('mcq_' + key) ? 'preview' : 'write'}
                          onTabChange={(value: any) => handleOptionTabChange(value, 'mcq_' + key)}
                          maxEditorHeight={85}
                          onChange={value => handleValueChange(value, key)}
                          generateMarkdownPreview={markdown => Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>)}
                          toolbarCommands={ReactMdeToolbarCommands}
                          paste={{
                            saveImage: saveOptions,
                          }}
                        /> */}
                        <>
                          <SunTextEditor 
                           key={key}
                           id={`${name}, option_text`}
                           initialValue={formProps.form?.getFieldValue(['option_details', index, 'option_text']) || ''}
                           formValueSetterFn={(content: string) => {
                           handleSetFormList(content, index, 'option_text')
                           }}
                          />
                        </>
                      </Form.Item>
                    </Col>
                    <Col lg={8}>
                      <Form.Item {...restField} label='Option Insight' name={[name, 'option_insight']} rules={[{ required: false }]}>
                        {/* <TextArea rows={7} placeholder="Option Insight" /> */}
                        <SunTextEditor
                            key={key}
                            id={`${name}, option_insight`}
                            // initialValue={initialOptions?.[key]?.['option_insight'] ?? ''}
                            initialValue={formProps.form?.getFieldValue(['option_details', index, 'option_insight']) || ''}
                            formValueSetterFn={(content: string) => {
                              handleSetFormList(content, index, 'option_insight')
                            }}
                          />
                      </Form.Item>
                    </Col>
                    <Col lg={3}>
                      <Form.Item {...restField} name={[name, 'option_flag']} rules={[{ required: true, message: 'Missing Option Flag' }]}>
                        <Select
                          placeholder="Option Flag"
                          style={{ width: 150 }}
                          // value={selectedItems}
                          onChange={handleOptionTags}
                          // onDeselect={handleDeselectOptionTags}
                          allowClear
                          options={filteredOptions.map(item => ({
                            value: item,
                            label: item,
                          }))}
                        />
                      </Form.Item>{' '}
                    </Col>
                    <Col lg={1}>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Col>
                  </Row>
                  // </Space>
                ))}
                {error ? <Typography.Text type="danger">Select atleast one Right Answer </Typography.Text> : null}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    Add Option
                  </Button>
                  <Form.ErrorList errors={errors} />
                </Form.Item>
              </>
            )}
          </Form.List>
        )}
        {questionType === 'Fill' && (
          <Form.List
            name="option_details"
            rules={[
              {
                validator: async (_, option_details) => {
                  console.log({ option_details })
                  if (option_details === undefined) {
                    return Promise.reject(new Error('Add at least 1 option'))
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                {fields.map(({ key, name, ...restField },index) => (
                  // <Space key={key} style={{ display: 'flex', marginBottom: 8, width: '100%' }} align="baseline">
                  <Row gutter={[8, 16]} style={{ display: 'flex', alignItems: 'center' }}>
                    <Col lg={12}>
                      <Form.Item {...restField} name={[name, 'right_answer']} rules={[{ required: true, message: 'Missing Option Answer' }]}>
                        {/* <TextArea rows={4} placeholder="Right Answer" /> */}
                        {/* <RichTextEditor
                          id={`option_details_fill_right_answer${name}`}
                          key={key}
                          formValueSetterFn={content => {
                            handleSetFormList(content, key, 'right_answer')
                          }}
                        /> */}
                         <SunTextEditor
                            id={`option_details_fill_right_answer${name}`}
                            key={key}
                            initialValue={formProps.form?.getFieldValue(['option_details', index, 'right_answer']) || ''}
                            formValueSetterFn={content => {
                              handleSetFormList(content, index, 'right_answer')
                            }}
                          />
                      </Form.Item>
                    </Col>
                    <Col lg={10}>
                      <Form.Item {...restField} name={[name, 'option_insights']} rules={[{ required: false }]}>
                      <SunTextEditor
                            key={key}
                            id={`${name}, option_insights`}
                            initialValue={formProps.form?.getFieldValue(['option_details', index, 'option_insights']) || ''}
                            formValueSetterFn={(content: string) => {
                              handleSetFormList(content, index, 'option_insights')
                            }}
                          />
                      </Form.Item>
                    </Col>
                    <Col lg={2}>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Col>
                  </Row>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    Add Option
                  </Button>
                  <Form.ErrorList errors={errors} />
                </Form.Item>
              </>
            )}
          </Form.List>
        )}
        {questionType === 'Match' && (
          <Form.List
            name="option_details"
            rules={[
              {
                validator: async (_, option_details) => {
                  console.log({ option_details })
                  if (option_details === undefined) {
                    return Promise.reject(new Error('Add at least 1 option'))
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                {fields.map(({ key, name, ...restField },index) => (
                  <>
                    <Row gutter={[8, 16]} style={{ display: 'flex', alignItems: 'center' }}>
                      <Col lg={8}>
                        <Form.Item {...restField} name={[name, 'left_label_text']} rules={[{ required: true, message: 'Missing Section' }]}>
                          {/* <ReactMde
                            selectedTab={selectedOptionTab?.includes('match_left_' + key) ? 'preview' : 'write'}
                            onTabChange={(value: any) => handleOptionTabChange(value, 'match_left_' + key)}
                            maxEditorHeight={75}
                            onChange={value => handleValueChange(value, key)}
                            generateMarkdownPreview={markdown => Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>)}
                            toolbarCommands={ReactMdeToolbarCommands}
                            paste={{
                              saveImage: saveOptions,
                            }}
                          /> */}
                          {/* <Input placeholder="Left Label" type="small" /> */}
                          <>
                            {/* <RichTextEditor
                              // handleImageUpload={handleImageUplodFromEditor}
                              key={key}
                              id={`match_option_left_label_${name}`}
                              formValueSetterFn={content => {
                                handleSetFormList(content, key, 'left_label_text')
                              }}
                            /> */}
                            <SunTextEditor
                              key={key}
                              id={`match_option_left_label_${name}`}
                              initialValue={formProps.form?.getFieldValue(['option_details', index, 'left_label_text']) || ''}
                              formValueSetterFn={content => {
                                handleSetFormList(content, index, 'left_label_text')
                              }}
                            />
                          </>
                        </Form.Item>
                      </Col>
                      <Col lg={8}>
                        <Form.Item {...restField} name={[name, 'right_label_text']} rules={[{ required: true, message: 'Missing Section' }]}>
                          {/* <ReactMde
                            selectedTab={selectedOptionTab?.includes('match_right_' + key) ? 'preview' : 'write'}
                            onTabChange={(value: any) => handleOptionTabChange(value, 'match_right_' + key)}
                            maxEditorHeight={75}
                            onChange={value => handleValueChange(value, key)}
                            generateMarkdownPreview={markdown => Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>)}
                            toolbarCommands={ReactMdeToolbarCommands}
                            paste={{
                              saveImage: saveOptions,
                            }}
                          /> */}
                          <>
                            {/* <RichTextEditor
                              // handleImageUpload={handleImageUplodFromEditor}
                              key={key}
                              id={`match_option_right_label_${name}`}
                              formValueSetterFn={content => {
                                handleSetFormList(content, key, 'right_label_text')
                              }}
                            /> */}
                            <SunTextEditor
                              key={key}
                              id={`match_option_right_label_${name}`}
                              initialValue={formProps.form?.getFieldValue(['option_details', index, 'right_label_text']) || ''}
                              formValueSetterFn={content => {
                                handleSetFormList(content, index, 'right_label_text')
                              }}
                            />
                          </>
                        </Form.Item>
                      </Col>
                      <Col lg={7}>
                        <Form.Item {...restField} name={[name, 'option_insight']} rules={[{ required: false }]}>
                          {/* <TextArea rows={5} placeholder="Option Insight" /> */}
                          <SunTextEditor
                            key={key}
                            id={`${name}, option_insight`}
                            initialValue={formProps.form?.getFieldValue(['option_details', index, 'option_insight']) || ''}
                            formValueSetterFn={(content: string) => {
                              handleSetFormList(content, index, 'option_insight')
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col lg={1}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Col>
                    </Row>
                  </>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    Add Option
                  </Button>
                  <Form.ErrorList errors={errors} />
                </Form.Item>
              </>
            )}
          </Form.List>
        )}
        {questionType === 'ShortAnswer' && (
          <Form.List
            initialValue={[
              {
                component_name: '',
                rating_1: '',
                rating_2: '',
                rating_3: '',
                rating_4: '',
                weightage: '',
              },
              {
                component_name: '',
                rating_1: '',
                rating_2: '',
                rating_3: '',
                rating_4: '',
                weightage: '',
              },
              {
                component_name: '',
                rating_1: '',
                rating_2: '',
                rating_3: '',
                rating_4: '',
                weightage: '',
              },
            ]}
            rules={[
              {
                validator: async (_, names) => {
                  if (names.length >= 8) {
                    return Promise.reject(new Error('Exceeded maximum rubric field. (Max is 7)'))
                  }
                },
              },
            ]}
            name="option_details"
          >
            {(fields, { add, remove }, { errors }) => {
              return (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                      <Form.Item {...restField} name={[name, 'component_name']} rules={[{ required: true, message: 'Missing Section' }]}>
                        <Input placeholder="Component Name" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_1']} rules={[{ required: true, message: 'Missing Rating 1' }]}>
                        <Input placeholder="Rating 1" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_2']} rules={[{ required: true, message: 'Missing Rating 2' }]}>
                        <Input placeholder="Rating 2" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_3']} rules={[{ required: true, message: 'Missing Rating 3' }]}>
                        <Input placeholder="Rating 3" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_4']} rules={[{ required: true, message: 'Missing Rating 4' }]}>
                        <Input placeholder="Rating 4" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'weightage']} rules={[{ required: true, message: 'Missing Weightage' }]}>
                        <Input placeholder="Weightage" type="small" style={{ maxWidth: 150 }} />
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                      Add Option
                    </Button>
                  </Form.Item>
                  <Form.ErrorList errors={errors} />
                </>
              )
            }}
          </Form.List>
        )}
        <Row gutter={[16, 0]}>
          {/* {(request?.competency_id === '' || request?.competency_id === null) &&
          (request?.taxonomy_id === '' || request?.taxonomy_id === null) &&
          (request?.strand_id === '' || request?.strand_id === null) &&
          (request?.bloom_level_id === '' || request?.bloom_level_id === null) &&
          (request?.difficulty_level_id === '' || request?.difficulty_level_id === null) ? (
            <Col xs={24} lg={24}>
              <Divider orientation="left" orientationMargin="0" className="primary">
                Tags
              </Divider>
            </Col>
          ) : null} */}
          {/* <Col xs={24} lg={24}>
            <Divider orientation="left" orientationMargin="0" className="primary">
              Tags
            </Divider>
          </Col> */}

          <Col xs={24} lg={16}>
            <Form.Item label="Competency" name="competency_id" rules={[{ required: true }]}>
              <Select onChange={handleCompetencyChange} {...competencySelectProps} />
            </Form.Item>
          </Col>

          <Col xs={24} lg={8}>
            <Form.Item label="Taxonomy" name="tn_taxonomy_id" rules={[{ required: taxonomyRequired }]}>
              <Select
                onChange={handleTaxonomyChange}
                {...tntaxonomySelectProps}
                disabled={
                  formProps?.form?.getFieldValue('competency_id') === undefined || formProps?.form?.getFieldValue('competency_id') === ''
                    ? true
                    : false
                }
              />
            </Form.Item>
          </Col>

          <Col xs={24} lg={8}>
            <Form.Item label="Standard" name="strand_id" rules={[{ required: true }]}>
              <Select
                {...strandSelectProps}
                disabled={
                  formProps?.form?.getFieldValue('tn_taxonomy_id') == null || formProps?.form?.getFieldValue('tn_taxonomy_id') == undefined
                    ? true
                    : false
                }
              />
            </Form.Item>
          </Col>

          {JSON.stringify(request) === '{}' || request?.blooms_level_id === '' || request?.blooms_level_id === null?(
             <Col xs={24} lg={8}>
             <Form.Item label="Choose the appropriate Bloom's taxonomy level" name="bloom_level_id" rules={[{ required: true }]}>
               <Select {...bloomlevelSelectProps} />
             </Form.Item>
           </Col>
          ):null
           }

          {JSON.stringify(request) === '{}' || request?.difficult_level_id === '' || request?.difficult_level_id === null?
          (<Col xs={24} lg={8}>
            <Form.Item label="Choose the appropriate difficulty level" name="difficulty_level_id" rules={[{ required: true }]}>
              <Select {...difficultylevelSelectProps} />
            </Form.Item>
          </Col>):null
            }

          {/* <Col lg={6}>
            <Form.Item label="Choose the reviewer's name" name="reviewer_id" rules={[{ required: true }]}>
              <Select options={reviewerList}></Select>
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item label="choose the approver's name" name="approver_id" rules={[{ required: true }]}>
              <Select options={approverList}></Select>
            </Form.Item>
          </Col> */}

          <Form.Item name="created_by" initialValue={user?.id}>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item name="user_type" initialValue={userRole}>
            <Input type="hidden" />
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  )
}
